import { Component } from '@angular/core';

interface Benefit {
  id: string;
  title: string;
  description: string;
  icon: string;
  features: string[];
}

@Component({
  selector: 'app-key-benefits',
  templateUrl: './key-benefits.component.html',
  styleUrls: ['./key-benefits.component.scss'],
  standalone: false,
})
export class KeyBenefitsComponent {
  benefits: Benefit[] = [
    {
      id: 'availability',
      title: 'Disponibilidad 24/7',
      description: 'Atención constante sin necesidad de personal adicional, mejorando la experiencia de tus clientes.',
      icon: 'bi-clock-history',
      features: [
        'Respuestas inmediatas en cualquier momento',
        'Sin tiempo de espera para tus clientes',
        'Atención en días festivos y fines de semana',
        'Escalabilidad para manejar picos de demanda'
      ]
    },
    {
      id: 'cost-reduction',
      title: 'Reducción de Costos',
      description: 'Disminución en gastos operativos al automatizar la atención al cliente y optimizar recursos.',
      icon: 'bi-cash-coin',
      features: [
        'Menor costo por interacción vs agentes humanos',
        'Reducción de personal para tareas repetitivas',
        'Optimización de procesos de atención',
        'Mayor eficiencia operativa'
      ]
    },
    {
      id: 'scalability',
      title: 'Escalabilidad',
      description: 'Capacidad para adaptarse al crecimiento del negocio sin complicaciones ni costos adicionales.',
      icon: 'bi-arrow-up-right',
      features: [
        'Gestión de miles de conversaciones simultáneas',
        'Adaptación a picos estacionales de demanda',
        'Expansión a nuevos mercados sin fricción',
        'Crecimiento sin limitaciones de personal'
      ]
    },
    {
      id: 'easy-integration',
      title: 'Integración Sencilla',
      description: 'Facilidad para conectar con sistemas existentes como CRM y ERP sin desarrollos complejos.',
      icon: 'bi-gear-wide-connected',
      features: [
        'Implementación en menos de 1 hora',
        'Conectores nativos para sistemas populares',
        'API documentada para integraciones personalizadas',
        'No requiere conocimientos técnicos avanzados'
      ]
    },
    {
      id: 'multilanguage',
      title: 'Soporte Multilingüe',
      description: 'Comunicación fluida en varios idiomas para atender a clientes internacionales y expandir mercados.',
      icon: 'bi-translate',
      features: [
        'Reconocimiento automático de idioma',
        'Capacidad para más de 20 idiomas',
        'Adaptación a expresiones locales',
        'Traducción en tiempo real'
      ]
    },
    {
      id: 'data-insights',
      title: 'Insights de Datos',
      description: 'Análisis detallados de conversaciones para descubrir tendencias y mejorar la toma de decisiones.',
      icon: 'bi-graph-up-arrow',
      features: [
        'Patrones de consultas frecuentes',
        'Detección de pain points de clientes',
        'Análisis de sentimiento',
        'Reportes personalizables'
      ]
    }
  ];

  // Track benefit expandido/colapsado
  expandedBenefitId: string | null = null;

  toggleBenefit(benefitId: string): void {
    this.expandedBenefitId = this.expandedBenefitId === benefitId ? null : benefitId;
  }

  isBenefitExpanded(benefitId: string): boolean {
    return this.expandedBenefitId === benefitId;
  }
}